import { DISCOVER } from "constants/types";

const initState = {
  categories: [],
  products: [],
  trending: [],
  productsInitialLoad: true,
  isProductSearching: false,
  mobileFilters: false,
  mobileSort: false,
}


const DiscoverReducer = (state = initState, action) => {

  const { type, payload } = action;

  switch(type) {

    case DISCOVER.CATEGORIES:
      return {
        ...state,
        categories: payload,
      }

    case DISCOVER.PRODUCTS_INITIAL_LOAD:
      return {
        ...state,
        productsInitialLoad: payload,
      }

    case DISCOVER.PRODUCTS_LOAD:
      return {
        ...state,
        isProductSearching: payload,
      }

    case DISCOVER.MOBILE_FILTERS:
      return {
        ...state,
        mobileFilters: payload,
      }

    case DISCOVER.MOBILE_SORT:
      return {
        ...state,
        mobileSort: payload,
      }

    case DISCOVER.PRODUCTS:
      return {
        ...state,
        products: [...payload.products],
        trending: [...payload.searches],
      }

    case DISCOVER.CLEAR:
      return {
        ...state,
        categories: [],
        products: [],
        productsInitialLoad: true,
        isProductSearching: false,
        mobileFilters: false,
        mobileSort: false,
      }


    default:
      return state
  }
}

export default DiscoverReducer